var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGermany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "germany_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    rx: -1,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#germany_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8h16v4H0V8z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4h16v4H0V4z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v4H0V0z",
    fill: "#272727"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 11,
    rx: 0.5,
    stroke: "#000",
    strokeOpacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }));
}

export default __webpack_public_path__ + "static/media/germany.5b80be01.svg";
export { SvgGermany as ReactComponent };